export default __webpack_public_path__ + "static/Card18-90a81ae66f7425e949d70a8650db0266.png";